const breakpoints = {
  mobile: 0,
  tablet: 768,
  desktop: 1024,
  large: 1440,
};

export const query = {
  maxMobile: `@media (max-width: ${breakpoints.tablet - 1}px)`,
  minTablet: `@media (min-width: ${breakpoints.tablet}px)`,
  tablet: `@media (min-width: ${breakpoints.tablet}px) and
     (max-width: ${breakpoints.desktop - 1}px)`,
  maxTablet: `@media (max-width: ${breakpoints.desktop - 1}px)`,
  minDesktop: `@media (min-width: ${breakpoints.desktop}px)`,
  desktop: `@media (min-width: ${breakpoints.desktop}px) and
  (max-width: ${breakpoints.large - 1}px)`,
  maxDesktop: `@media (max-width: ${breakpoints.large - 1}px)`,
  minLarge: `@media (min-width: ${breakpoints.large}px)`,
};
